import { Component, Input } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-agreements-data-preview',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './agreements-data-preview.component.html'
})
export class AgreementsDataPreviewComponent {
  @Input()
  public application: ApplicationAppEntityApplicationRead | null = null;
}
